(function () {
  'use strict';

  function initQuiz(root) {
    if (!root || root.dataset.quizReady === 'true') return;
    root.dataset.quizReady = 'true';

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-step]'));
    var progressBar = root.querySelector('[data-quiz-progress]');
    var backBtn = root.querySelector('[data-quiz-back]');
    var restartBtn = root.querySelector('[data-quiz-restart]');
    var resultEl = root.querySelector('[data-quiz-result]');
    var current = 0;
    var answers = {};

    var profiles = {
      fresh: {
        title: 'Frisk & Citrus',
        text: 'Du elsker lette, opkvikkende dufte med citrus, hav og grønne noter, perfekt til hverdagen.'
      },
      floral: {
        title: 'Blomstret & Feminin',
        text: 'Du er til bløde, elegante blomsterdufte med jasmin, rose og pudrede noter.'
      },
      woody: {
        title: 'Træagtig & Maskulin',
        text: 'Du foretrækker dybe, markante dufte med cedertræ, læder og aromatiske accenter.'
      },
      sweet: {
        title: 'Sød & Orientalsk',
        text: 'Du falder for varme, sensuelle dufte med vanilje, amber og orientalske krydderier.'
      },
      musk: {
        title: 'Musk & Pudret',
        text: 'Du kan lide bløde, hudnære dufte med musk, iris og cremede noter.'
      },
      spicy: {
        title: 'Krydret & Varmt',
        text: 'Du er til modige dufte med peber, kanel og røg, karakterfulde og mindeværdige.'
      }
    };

    var plans = {
      surprise: {
        name: '1 Overraskelse',
        price: '119 kr/md',
        text: 'Vi kuraterer en designerduft til dig hver måned, perfekt hvis du elsker at blive overrasket.',
        url: '/products/1-overraskelse',
        cta: 'Start Overraskelse'
      },
      choice: {
        name: '1 Valgfri',
        price: '139 kr/md',
        text: 'Vælg selv blandt vores designerdufte hver måned, ideelt når du ved, hvad du kan lide.',
        url: '/products/1-valgfri',
        cta: 'Vælg selv min duft'
      },
      combo: {
        name: 'Valgfri & Overraskelse',
        price: '165 kr/md',
        text: 'Den bedste kombination: én duft du vælger, og én vi overrasker dig med.',
        url: '/products/1-valgfri-1-overraskelse',
        cta: 'Få begge dele'
      }
    };

    function showStep(index, scroll) {
      steps.forEach(function (step, i) {
        step.hidden = i !== index;
      });
      current = index;

      if (progressBar) {
        var total = steps.length - 1;
        var pct = total > 0 ? Math.round((Math.min(index, total - 1) / (total - 1)) * 100) : 0;
        if (index >= steps.length - 1) pct = 100;
        progressBar.style.width = pct + '%';
      }

      if (backBtn) {
        backBtn.hidden = index === 0 || index >= steps.length - 1;
      }

      if (scroll) {
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function renderResult() {
      var profile = profiles[answers.profile] || profiles.floral;
      var plan = plans[answers.plan] || plans.combo;
      var audience = answers.audience || 'any';

      var audienceText = audience === 'women'
        ? 'Vi har taget højde for, at du leder efter dufte til kvinder.'
        : audience === 'men'
          ? 'Vi har taget højde for, at du leder efter dufte til mænd.'
          : 'Vi har fundet en anbefaling, der passer til dig.';

      if (!resultEl) return;

      resultEl.innerHTML = [
        '<span class="sc-quiz-app__result-label">Din duftprofil</span>',
        '<h2 class="sc-quiz-app__result-title">' + profile.title + '</h2>',
        '<p class="sc-quiz-app__result-text">' + profile.text + '</p>',
        '<p class="sc-quiz-app__result-sub">' + audienceText + '</p>',
        '<div class="sc-quiz-app__result-card">',
        '  <span class="sc-quiz-app__result-plan-label">Anbefalet abonnement</span>',
        '  <h3 class="sc-quiz-app__result-plan-name">' + plan.name + '</h3>',
        '  <p class="sc-quiz-app__result-plan-price">' + plan.price + '</p>',
        '  <p class="sc-quiz-app__result-plan-text">' + plan.text + '</p>',
        '  <a href="' + plan.url + '" class="sc-btn sc-btn--gold sc-btn--lg sc-track-cta" data-cta="quiz-result">' + plan.cta + '</a>',
        '</div>',
        '<a href="/collections/abonnementer" class="sc-quiz-app__browse">Se alle abonnementer</a>'
      ].join('');
    }

    root.addEventListener('click', function (event) {
      var option = event.target.closest('[data-quiz-answer]');
      if (!option) return;

      var step = option.closest('[data-quiz-step]');
      if (!step) return;

      var key = step.dataset.quizStep;
      var value = option.dataset.quizAnswer;
      answers[key] = value;

      step.querySelectorAll('[data-quiz-answer]').forEach(function (btn) {
        btn.classList.toggle('is-selected', btn === option);
      });

      window.setTimeout(function () {
        if (current >= steps.length - 2) {
          renderResult();
        }
        showStep(Math.min(current + 1, steps.length - 1), true);
      }, 220);
    });

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (current > 0) showStep(current - 1, true);
      });
    }

    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        answers = {};
        steps.forEach(function (step) {
          step.querySelectorAll('[data-quiz-answer]').forEach(function (btn) {
            btn.classList.remove('is-selected');
          });
        });
        showStep(0, true);
      });
    }

    showStep(0, false);
  }

  function boot() {
    document.querySelectorAll('[data-scenty-quiz]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-scenty-quiz]');
    if (root) initQuiz(root);
  });
})();
